// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ex","title":"_ey","subtitle":"_ez","button":"_eA","report_image":"_eB","underlined_report":"_eC","close":"_eD","cross":"_eE"};